import { convertToTitleCase } from './helpers';

// --------------------------------
// Section One
// --------------------------------

export const sectionOneValidation = (payload) => {
  if (payload['company-name'].length === 0) return false;
  if (payload['street-address'].length === 0) return false;
  if (payload.city.length === 0) return false;
  if (payload.state.length === 0) return false;
  if (payload.zip.length === 0) return false;
  if (payload['company-phone'].length === 0) return false;
  return true;
};

export const handleSectionOneValidationError = () =>
  alert(
    `Please answer all required fields:
      Company Address
      Company City
      Company State
      Company Zip
      Company Phone`
  );

// --------------------------------
// Section Two
// --------------------------------

export const sectionTwoValidation = (formData) => {
  const {
    acquiredThisYear,
    acquiredThisYearCompany,
    acquisitionsThisYear,
    acquisitionEntities
  } = formData;

  if (acquiredThisYear === 'yes' && !acquiredThisYearCompany.length > 0) {
    return false;
  }

  if (acquisitionsThisYear === 'yes' && !acquisitionEntities.length > 0) {
    return false;
  }

  if (acquisitionsThisYear.length === 0 && acquiredThisYear.length === 0) {
    return false;
  }

  return true;
};

export const handleSectionTwoValidationError = () =>
  alert(
    'Please answer all questions to Continue or save progress by returning to Dashboard'
  );

// --------------------------------
// Section Three
// --------------------------------

export const sectionThreeValidation = (formData) => {
  const {
    ownedPropaneStorage,
    ownedPropaneStorageGallons,
    contractedPropaneStorage,
    contractedPropaneStorageGallons,
    propaneRelatedRevenue
  } = formData;

  if (
    ownedPropaneStorage === 'yes' &&
    (ownedPropaneStorageGallons === null || !ownedPropaneStorageGallons)
  ) {
    return false;
  }

  if (
    contractedPropaneStorage === 'yes' &&
    (contractedPropaneStorageGallons === null ||
      !contractedPropaneStorageGallons)
  ) {
    return false;
  }

  if (
    ownedPropaneStorage.length === 0 ||
    contractedPropaneStorage.length === 0 ||
    propaneRelatedRevenue.length === null
  ) {
    return false;
  }

  return true;
};

export const handleSectionThreeValidationError = () =>
  alert(
    'Please answer all questions to Continue or save progress by returning to Dashboard'
  );

// --------------------------------
// Section Four
// --------------------------------

export const sectionFourValidation = (payload) => {
  if (payload.statesServiced.length === 0) return false;

  return true;
};

export const handleSectionFourValidationError = () =>
  alert(
    'Please ensure at least one state is selected to Continue or save progress by returning to Dashboard'
  );

// --------------------------------
// Section Five
// --------------------------------

export const sectionFiveValidation = (statesData) => {
  const validationErrors = statesData.map((stateData) =>
    stateItemValidation(stateData)
  );

  if (validationErrors.includes(false)) return false;

  return true;
};

export const handleSectionFiveValidationError = () =>
  alert(
    'All fields must be complete to Continue or save progress by returning to Dashboard.  Enter “0” if appropriate.'
  );

// since nulls are allowed, checks to make sure number inputs are NaN to report error
export const stateItemValidation = (stateInfo, isAltForm) => {
  for (const [key, value] of Object.entries(stateInfo)) {
    if (Number.isNaN(value)) return false;
  }

  return true;
};

export const handleStateItemValidationError = (stateName) => {
  if (stateName) {
    stateName = convertToTitleCase(stateName);
  }

  alert(
    `Please complete all required fields before saving${
      stateName ? ` ${stateName}` : ''
    }. Enter “0” if appropriate. If you’re not ready to complete this state you can return the dashboard instead.`
  );
};
